<template>
  <div class="two-row-block">
    <div class="container small-container">
      <h2 class="section-header two-row-block__header">
        Worried about losing connectivity?
      </h2>
      <p class="two-row-block__content">
        Get a disruption-free guarantee by adding the EE 4G Assure / Mi-Fi dongle to your broadband for just £10 a month.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TwoRowBlock'

}
</script>

<style lang="scss">
.two-row-block {
  padding: $spacing-60 $spacing-0;
  background-color: $two-row-block-bg;

  &__content {
    margin-bottom: $spacing-0;
    text-align: center;
  }

  @media (max-width: $screen-md) {
    padding: $spacing-28 $spacing-0;

    &__header {
      margin-bottom: $spacing-12;
    }

    &__content {
      text-align: left;
      font-size: 16px;
      line-height: 24px;
    }
  }
}
</style>
